import React from 'react';
import {
  FDHeadlineText,
  FDPaper, FDStack,
  FDTable,
  FDTableBody,
  FDTableCell,
  FDTableHead,
  FDTableRow,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';

export default function TransitionsDashboardPageScheduledAchTransfers({ collection }) {
  function getRows() {
    if (collection.resources().length() === 0) {
      return (
        <FDTableRow>
          <FDTableCell>No scheduled transfers</FDTableCell>
        </FDTableRow>
      );
    }

    return collection.resources().list().map((transfer) => (
      <FDTableRow key={transfer.id()}>
        <FDTableCell>{transfer.attr('account')}</FDTableCell>
        <FDTableCell align={'right'}>{transfer.attr('amount')}</FDTableCell>
        <FDTableCell>{transfer.attr('frequency')}</FDTableCell>
        <FDTableCell>{transfer.attr('nextTransferDate')}</FDTableCell>
      </FDTableRow>
    ));
  }
  return (
    <FDPaper appearance={'elevated'} margin={300} padding={500} flex={1}>
      <FDStack spacing={2} direction={'column'}>
        <FDHeadlineText value={'Scheduled Transactions'} color={'textSecondary'} />
        <FDTable>
          <FDTableHead>
            <FDTableRow>
              <FDTableCell>Account</FDTableCell>
              <FDTableCell>Amount</FDTableCell>
              <FDTableCell>Frequency</FDTableCell>
              <FDTableCell>Next Transfer Date</FDTableCell>
            </FDTableRow>
          </FDTableHead>
          <FDTableBody>
            {getRows()}
          </FDTableBody>
        </FDTable>
      </FDStack>
    </FDPaper>
  );
}

TransitionsDashboardPageScheduledAchTransfers.propTypes = {
  collection: PropTypes.object.isRequired,
};

TransitionsDashboardPageScheduledAchTransfers.defaultProps = {};
